import React from 'react'

export const Icon = (props) => {
  return (<div data-filetype={props.filetype} className='filepicker-file-icon' />)
}



// WEBPACK FOOTER //
// ./D:/Code/React-Dropzone-Component/src/icon.js